import api from './api';

export function getEducational() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/clients/education-levels`);
}
